var map = {
	"./de/returnBtn.png": "RQo9",
	"./en/returnBtn.png": "YCjE",
	"./es/returnBtn.png": "ZLOc",
	"./fr/returnBtn.png": "Bbnp",
	"./ja/returnBtn.png": "+/yz",
	"./ko/returnBtn.png": "kJXq",
	"./pt/returnBtn.png": "dtaM",
	"./ru/returnBtn.png": "31r2",
	"./tc/returnBtn.png": "Kfae",
	"./th/returnBtn.png": "mb4W"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9Sv0";